import { Box, Stack, Typography } from '@mui/material';
import Logo from '../../assets/images/logo/starcard_club_white.png';

const StarCardLoading = () => {
  return (
    <Stack
      alignItems={'center'}
      justifyContent={'center'}
      sx={{ height: '100dvh', background: '#005972', position: 'relative' }}
    >
      <Box
        sx={{
          width: '0',
          height: '0',
          borderStyle: 'solid',
          borderWidth: '0 0px 300px 320px',
          borderColor: 'transparent transparent #E1000C transparent',
          transform: 'rotate(0deg)',
          position: 'absolute',
          bottom: '0',
          right: '0',
          zIndex: '10',
        }}
      />
      <Typography
        sx={{
          width: '200px',
          fontSize: '20px',
          color: 'white',
          fontWeight: '500',
          textAlign: 'center',
          position: 'absolute',
          bottom: '40px',
          right: '0',
          zIndex: '11',
        }}
      >
        SMART CONTROL,
        <br />
        TRUSTED FUEL.
      </Typography>
      <Box component={'img'} src={Logo} alt="Starcard Club Logo" sx={{ height: '120px' }} />
    </Stack>
  );
};

export default StarCardLoading;
